export default {
  polls: [],
  poll: {},
  results: [],
  currentPollResults: {}
};
